import '../helpers/Extensions';
import promiseFinally from 'promise.prototype.finally';

// Add `finally()` to `Promise.prototype`
promiseFinally.shim();

/**
 * Type Definitions
 *
 * A Redux store.
 *
 * @typedef {Object} Store
 * @property {Function} dispatch Dispatch a provided action with type to invoke a matching reducer.
 * @property {Function} getState Get the current global state.
 * @property {Function} subscribe Provide callback to be invoked every time an action is fired.
 * @property {Function} replaceReducer Replace an existing reducer with a new one.
 */

class Container {

	/**
	 * @type {Store}
	 */
	_store;

	/**
	 * Get Redux Store State
	 *
	 * @return {*}
	 */
	get state() {
		return this.store.getState();
	}

	/**
	 * @return {Store}
	 */
	get store() {
		if (!this._store) {
			throw new Error('Container must have a Redux Store set. Please use container.setStore() method.');
		}
		return this._store;
	}

	/**
	 * @param {Store} store
	 */
	setStore(store) {
		this._store = store;
	}
}

const container = new Container();

export default container;


// WEBPACK FOOTER //
// ./services/Container.js